<script setup lang="ts">
import { ref, onMounted, onUnmounted } from 'vue'
import { hall } from '@/hall'
import { ActivityList, BINDACTIVITY } from '@/modules/BindActivityModule'
import { EventDefine } from '@/defines/EventDefine'
import OverlayMask from '@/components/OverlayMask.vue'

const emit = defineEmits(['close', 'clickAct'])

interface ActivityData {
  id: number
  type: number
  label: string
  icon: string
  badge: boolean
}

const localActivities = ref<ActivityData[]>([])

const getIconPath = (iconName: string) => {
  return new URL(`../assets/hall/bindActivity/${iconName}.webp`, import.meta.url).href
}

const getActivityNames = (id: number, stringList: Record<string, string>) => {
  const key = ActivityList[id]
  if (!key || typeof key !== 'string') {
    return 'Unknown Activity'
  }
  const text = stringList[key]
  if (!text) {
    return key
  }
  return text
}

const refreshActivities = () => {
  const info = hall.bindActivityModule.activityList || []
  const list: ActivityData[] = []
  
  const pannel = BINDACTIVITY

  for (let i = 0; i < info.length; i++) {
    const id = info[i] as unknown as number
    if (id === undefined) continue
    const key = ActivityList[id] as string
    const str = getActivityNames(id, pannel)
    
    let badge = false 
    if (key === 'LuckyWheel') badge = hall.bindActivityModule.turnTableRed
    else if (key === 'DailyCash') badge = hall.bindActivityModule.signRed
    else if (key === 'FreeSpinEveryday') badge = hall.bindActivityModule.freeSpinRed
    else if (key === 'Bonus') badge = hall.bindActivityModule.diamondRed
    else if (key === 'Rank') badge = hall.bindActivityModule.rankRed
    else if (typeof (hall.bindActivityModule as unknown as Record<string, boolean>)[`${key}Red`] !== 'undefined') {
      badge = !!(hall.bindActivityModule as unknown as Record<string, boolean>)[`${key}Red`]
    }

    list.push({
      id: id,
      type: id,
      label: str,
      icon: key,
      badge: badge
    })
  }

  localActivities.value = list
}

onMounted(() => {
  refreshActivities()
  if (localActivities.value.length === 0) {
    hall.bindActivityModule.changeRedStatus() 
  }
  hall.eventDispatcher.on(EventDefine.ChangeActivityRed, refreshActivities)
})

onUnmounted(() => {
  hall.eventDispatcher.off(EventDefine.ChangeActivityRed, refreshActivities)
})
</script>

<template>
  <OverlayMask @close="emit('close')">
    <div class="more-actions-popup">
      <div class="popup-actions-grid">
        <div v-for="act in localActivities" :key="'popup-' + act.type" class="action-item cursor-pointer" @click="emit('clickAct', act)">
          <div class="kuang-bg">
            <img src="@/assets/hall/kuang.png" class="kuang-img" alt=""/>
            <div class="icon-wrap dynamic-icon">
              <img :src="getIconPath(act.icon)" class="act-img" />
              <span v-if="act.badge" class="badge"></span>
            </div>
          </div>
          <span class="action-label" v-html="act.label.replace(' ', '<br/>')"></span>
        </div>

        <div class="action-item cursor-pointer" @click="emit('close')">
          <div class="kuang-bg">
            <img src="@/assets/hall/kuang.png" class="kuang-img" alt=""/>
            <div class="icon-wrap more-events-btn">
              <img src="@/assets/hall/down.png" class="close-icon" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </OverlayMask>
</template>

<style scoped>
.more-actions-popup {
  position: relative;
  width: 95%;
  background: var(--theme-lobby-bg);
  backdrop-filter: blur(20px);
  border: 2px solid var(--theme-border-card);
  border-radius: 12px;
  padding: 20px 5px;
  box-shadow: 0 10px 30px rgba(0,0,0,0.8);
}

.popup-actions-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 20px 0;
}

.action-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  text-align: center;
  color: #fff;
  width: 100%;
}

.action-label {
  font-size: 0.8rem;
  line-height: 1.2;
}

.kuang-bg {
  position: relative;
  width: 72px;
  height: 72px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.kuang-img {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  z-index: 1;
}

.icon-wrap {
  width: 52px;
  height: 52px;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 2;
  border-radius: 12px;
}

.more-events-btn {
  color: var(--theme-accent);
}

.close-icon {
  width: 40px;
  height: auto;
  object-fit: contain;
  transform: rotate(180deg);
}

.act-img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.badge {
  position: absolute;
  top: -2px;
  right: -2px;
  width: 12px;
  height: 12px;
  background: #ff3b30;
  border-radius: 50%;
  border: 1px solid var(--theme-nav-bg);
  z-index: 5;
}
</style>
